<template>
  <CContainer fluid>
    <CRow alignHorizontal="between" class="row-header">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Certificate</div>
          <div class="line" />
        </div>
      </div>
      <div class="row-card-title right">
        <div>
          <div class="button button-icon button-green">
            Export Report
            <img src="@/assets/images/admin/Download.svg" class="icon icon-invert" />
          </div>
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="between" class="row-header">
            <div class="button button-icon button-orange" @click="setIsCertificateModalShow()">
              Add Certificate
              <img src="@/assets/images/admin/Plus.svg" class="icon" />
            </div>
            <div>
              <div class="input-group">
                <input placeholder="SEARCH" class="custom-input" />
                <img src="@/assets/images/admin/Search.svg" class="icon" />
              </div>
            </div>
          </CRow>
          <CRow>
            <table style="width: 100%; text-align: center; font-size: 20px; color: #000">
              <tr style="font-weight: bold">
                <th>NUM</th>
                <th>COURSE CODE</th>
                <th>COURSE NAME</th>
                <th>ACTION</th>
              </tr>
              <template v-for="course of courses">
                <tr :key="course">
                  <td>{{course.id + 1 }}</td>
                  <td>{{course.courseCode}}</td>
                  <td>{{course.CourseName}}</td>
                  <td>
                    <div style="color: #0080FF; text-decoration: underline; cursor: pointer">VIEW</div>
                  </td>
                </tr>
              </template>
            </table>
          </CRow>
        </CContainer>
      </div>
    </CRow>
    <CertificateModal
      :modalVisible="isCertificateModalShow"
      :setModalVisible="setIsCertificateModalShow"
    />
  </CContainer>
</template>

<script>
import CertificateModal from "../../modal/CertificateModal";

const items = [
  {
    courseCode: "000000",
    CourseName: "XXXXXX"
  },
  {
    courseCode: "000001",
    CourseName: "XXXXXX"
  },
  {
    courseCode: "000002",
    CourseName: "XXXXXX"
  },
  {
    courseCode: "000003",
    CourseName: "XXXXXX"
  }
];

export default {
  name: "Certificate",
  components: {
    CertificateModal
  },
  data() {
    return {
      isCertificateModalShow: false,
      courses: items.map((item, id) => {
        return { ...item, id };
      })
    };
  },
  methods: {
    setIsCertificateModalShow() {
      this.isCertificateModalShow = !this.isCertificateModalShow;
    }
  }
};
</script>
